import { Apps } from '@/constants/apps';
import { LocalStorageAdapter } from './adapter/adapters';

enum StorageKey {
  LOCALE = 'game/locale',
  COOKIE_CONSENT = 'game/cookie-consent',
  INSTALL_PROMPT = 'game/install-prompt',
  TEMP_ID = 'temp-id',
  MARKETING_PARAMS = 'marketing-params',
  FRAME_SEARCH_PARAMS = 'game/frame-search-params',
}

const storage = new LocalStorageAdapter();

export default class MainStorage {
  static saveMarketingParams(app: Apps, marketingParams: Dictionary<string | number>): void {
    const actualKey = `${app}/${StorageKey.MARKETING_PARAMS}`;
    storage.setItem(actualKey, marketingParams);
  }

  static getMarketingParams(app: Apps): Dictionary<string | number> {
    const actualKey = `${app}/${StorageKey.MARKETING_PARAMS}`;
    const result = storage.getItem(actualKey);
    if (typeof result === 'object' && !Array.isArray(result) && result !== null) {
      return result;
    }
    return {};
  }

  static saveFrameSearchParams(
    frameSearchParams: Dictionary<string | (string | null)[] | null | undefined>
  ): void {
    storage.setItem(StorageKey.FRAME_SEARCH_PARAMS, frameSearchParams);
  }

  static getFrameSearchParams(): Dictionary<string | (string | null)[] | null | undefined> {
    const savedParams = storage.getItem(StorageKey.FRAME_SEARCH_PARAMS);
    if (typeof savedParams === 'object' && !Array.isArray(savedParams) && savedParams !== null) {
      return savedParams;
    }
    return {};
  }

  static saveLocale(locale: string): void {
    storage.setItem(StorageKey.LOCALE, locale);
  }

  static getLocale(): string | null {
    return storage.getItem(StorageKey.LOCALE);
  }

  static saveCookieConsent(consent: boolean): void {
    storage.setItem(StorageKey.COOKIE_CONSENT, consent);
  }

  static getCookieConsent(): boolean | null {
    return storage.getItem(StorageKey.COOKIE_CONSENT);
  }

  static saveInstallPrompt(outcome: string): void {
    storage.setItem(StorageKey.INSTALL_PROMPT, outcome);
  }

  static getInstallPrompt(): string | null {
    return storage.getItem(StorageKey.INSTALL_PROMPT);
  }

  static saveTempId(app: Apps, tempId: string): void {
    const actualKey = `${app}/${StorageKey.TEMP_ID}`;
    storage.setItem(actualKey, tempId);
  }

  static getTempId(app: Apps): string | null {
    const actualKey = `${app}/${StorageKey.TEMP_ID}`;
    const legacyKey = `game/${StorageKey.TEMP_ID}`;

    const result = storage.getItem(actualKey);
    if (typeof result === 'string') {
      return result;
    }
    return storage.getItem(legacyKey);
  }
}
